import { FoodManagementControls } from "@enos-monorepo/lib";
import { useState } from "react";

export default function useFoodManagementModals() {
  const initialModalState = Object.values(FoodManagementControls).reduce(
    (acc, control) => {
      acc[control] = false;
      return acc;
    },
    {} as Record<FoodManagementControls, boolean>,
  );
  const [modalOpen, setModalOpen] =
    useState<Record<FoodManagementControls, boolean>>(initialModalState);

  function openModal(type: FoodManagementControls) {
    setModalOpen((prev) => {
      return {
        ...prev,
        [type]: true,
      };
    });
  }
  function closeModals() {
    setModalOpen(initialModalState);
  }

  return {
    openModal,
    modalOpen,
    closeModals,
  };
}
